import { render } from "./modalArticle.vue?vue&type=template&id=349536f0"
import script from "./modalArticle.vue?vue&type=script&lang=js"
export * from "./modalArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__